import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config';


const SYMBOLS = {
  eur: '\u20ac', usd: '$', gbp: '\u00a3', chf: 'CHF', cad: 'C$', jpy: '\u00a5', aud: 'A$',
};

const LABELS = {
  eur: 'EUR (\u20ac)', usd: 'USD ($)', gbp: 'GBP (\u00a3)', chf: 'CHF', cad: 'CAD (C$)', jpy: 'JPY (\u00a5)', aud: 'AUD (A$)',
};

const SUPPORTED = ['eur', 'usd', 'gbp', 'chf', 'cad', 'jpy', 'aud'];

const CurrencyContext = createContext({
  currency: 'eur', symbol: '\u20ac', setCurrency: () => {},
  currencies: SUPPORTED, labels: LABELS, symbols: SYMBOLS,
});

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem('hexopdf_currency') || 'eur');

  useEffect(() => {
    const stored = localStorage.getItem('hexopdf_currency');
    if (stored) return;
    axios.get(`${API}/geo/currency`).then(r => {
      const c = SUPPORTED.includes(r.data.currency) ? r.data.currency : 'eur';
      setCurrencyState(c);
      localStorage.setItem('hexopdf_currency', c);
    }).catch(() => {});
  }, []);

  const setCurrency = (c) => {
    const val = SUPPORTED.includes(c) ? c : 'eur';
    setCurrencyState(val);
    localStorage.setItem('hexopdf_currency', val);
  };

  return (
    <CurrencyContext.Provider value={{
      currency,
      symbol: SYMBOLS[currency] || '\u20ac',
      setCurrency,
      currencies: SUPPORTED,
      labels: LABELS,
      symbols: SYMBOLS,
    }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
